const asPercent = (i) => `${(i * 100).toFixed(2)}%`;

const DisplayFunctions = {
    asPercent,
};

export { DisplayFunctions };
